import React, { Component, useState } from "react";
import "../Styles/AskModal.css";

export const ConfirmEmailCode = ({ email, confirm, close }) => {
  return (
    <div className="AskContainer" style={{position: "fixed"}}>
      <div className="card AskCard">
        <div
          className="card-footer"
          style={{ background: "#fff", borderTop: "0px" }}
        >
          <div className="AskFooter">
          <button
              className="AskBtn"
              onClick={() => close()}
            >
              En otro momento
            </button>
            <button
              className="AskBtn"
              disabled={code.length < 6}
              onClick={() => confirm(email)}
            >
              Re-enviar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
  
};
